export default "__VITE_ASSET__BVV_418U__"